import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import '@/assets/styles/reset.css'
import '@/assets/icons'
import '@/permission'

import ElementUI from 'element-ui'
import lang from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import '../static/theme/index.css'
import './assets/styles/global.scss'

import '@/custom-components';

Vue.use(ElementUI, { locale: lang })

Vue.config.productionTip = false
Vue.prototype.console = console;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js